import axios from 'axios';
import get from 'lodash/get';

// Libs
import { thunkErrorHanlder, parseUrl } from '../../libs/utils';

// Constants
import {
  ADMIN_TEMPLATE_SMS,
  ADMIN_EDIT_TEMPLATE_SMS
} from '../../constants/endpoints';

// Store
import store from '../../app/store';

export const NEW_SURA_TEMPLATES_SMS                       = 'NEW_SURA_TEMPLATES_SMS';
export const NEW_CHANGE_CARD_TEMPLATE_SMS                 = 'NEW_CHANGE_CARD_TEMPLATE_SMS';
export const NEW_PAYMENT_LINK_TEMPLATE_SMS                = 'NEW_PAYMENT_LINK_TEMPLATE_SMS';
export const NEW_DIRECT_PAYMENT_PROCESS_TEMPLATE_SMS      = 'NEW_DIRECT_PAYMENT_PROCESS_TEMPLATE_SMS';
export const NEW_AGENT_PAYMENT_PROCESS_TEMPLATE_SMS       = 'NEW_AGENT_PAYMENT_PROCESS_TEMPLATE_SMS';
export const NEW_DIRECT_INSUFFICIENT_FUNDS_TEMPLATE_SMS   = 'NEW_DIRECT_INSUFFICIENT_FUNDS_TEMPLATE_SMS';
export const NEW_AGENT_INSUFFICIENT_FUNDS_TEMPLATE_SMS    = 'NEW_AGENT_INSUFFICIENT_FUNDS_TEMPLATE_SMS';
export const SUBMIT_LOADING                               = 'SUBMIT_LOADING';

/**
 * getSuraSmsTemplates - This function get SURA sms templates
 * @return {array} data from SURA sms templaes
 */
export async function getSuraSmsTemplates() {
  function parseTemplates(response, dispatch){
    const templates = get(response, 'data.catalogs');
    dispatch({ type: NEW_SURA_TEMPLATES_SMS, payload: templates });

    if (Array.isArray(templates)) templates.forEach(template => {
      const templateId = get(template, 'id');

      switch(templateId){
        // Link de pago
        case 1:
          dispatch({ type: NEW_PAYMENT_LINK_TEMPLATE_SMS, payload: template })
          break;

        // Cambio de tarjeta
        case 2:
          dispatch({ type: NEW_CHANGE_CARD_TEMPLATE_SMS, payload: template })
          break;
          
        // Agente - Fondos insuficientes
        case 3:
          dispatch({ type: NEW_AGENT_INSUFFICIENT_FUNDS_TEMPLATE_SMS, payload: template })
          break;

        // Directo - Fondos insuficientes
        case 4:
          dispatch({ type: NEW_DIRECT_INSUFFICIENT_FUNDS_TEMPLATE_SMS, payload: template })
          break;

        // Agente - Procesar pago
        case 5:
          dispatch({ type: NEW_AGENT_PAYMENT_PROCESS_TEMPLATE_SMS, payload: template })
          break;

        // Directo - Procesar pago
        case 6:
          dispatch({ type: NEW_DIRECT_PAYMENT_PROCESS_TEMPLATE_SMS, payload: template })
          break;

        default:
          break;

      } // END switch

    }); // END forEach

    return templates;

  } // END parseTemplates

  const { retries_token } = get(store.getState(), 'account');
  const headers = new Headers();
  headers.set('Authorization', retries_token);

  const axiosInstance = axios.create({
    headers: {
      Authorization: `Bearer ${retries_token}`
    }
  });

  return dispatch => axiosInstance.get(ADMIN_TEMPLATE_SMS)
    .then(response => parseTemplates(response, dispatch))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getSuraSmsTemplates

/**
 * updateSuraSmsTemplateById - This function update SURA sms templates
 * @return {array} data
 */
export function updateSuraSmsTemplateById(uuid, body) {
  const { retries_token } = get(store.getState(), 'account');
  const user_uuid = get(store.getState(), 'account.uuid')

  let newFields = [];

  const getFields = message => {
    let allFields = [];
    const msg = message
    if(msg.includes('{name}')) {
      allFields = [ ...allFields, 'name']
    }
    if(msg.includes('{product_name}')) {
      allFields = [ ...allFields, 'product_name']
    }
    if(msg.includes('{agent_name}')) {
      allFields = [ ...allFields, 'agent_name']
    }
    if(msg.includes('{url}')) {
      allFields = [ ...allFields, 'url']
    }
    return allFields;
  }

  if (get(body, 'content') || get(body, 'message')) {
    const messageSmsTemplate = get(body, 'content') ? get(body, 'content') : get(body, 'message');
    newFields = getFields(messageSmsTemplate);
  }

  const newBody = {
    subject: get(body, 'subject'),
    fields: newFields,
    message: get(body, 'content') ? get(body, 'content') : get(body, 'message')
  }

  const axiosInstance = axios.create({
    headers: {
      Authorization: `Bearer ${retries_token}`,
      'user-uuid': `${user_uuid}`,
    }
  });

  return dispatch => axiosInstance.patch(parseUrl(ADMIN_EDIT_TEMPLATE_SMS, { uuid }), newBody)

} // END updateTemplateById



// WEBPACK FOOTER //
// ./src/redux/actions/suraSmsTemplateActions.js